import {
    EXPENSE_EXPORT_FETCHING,
    EXPENSE_EXPORT_FAILED,
    EXPENSE_EXPORT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EXPENSE_EXPORT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EXPENSE_EXPORT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EXPENSE_EXPORT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
